<template>
	<div>
		<v-layout row wrap>
			<v-flex lg3 md6 sm6 xs12 class="pr-3">
				<v-text-field v-debounce:300ms="updateSearch" append-icon="search" label="Search" autofocus="" background-color="#fff"></v-text-field>
			</v-flex>
			<v-spacer></v-spacer>
			<v-btn color="primary" @click="onAddClick">Add new permission group</v-btn>
		</v-layout>
		<v-data-table disable-initial-sort :headers="headers" :items="securityGroups" hide-actions class="elevation-1" :loading="isLoading" :search="search" :pagination.sync="pagination">
			<template slot="items" slot-scope="props">
				<tr>
					<td class="text-xs-left"><a href="#" @click.prevent.stop="onEditClick(props.item)">{{ props.item.name }}</a></td>
					<td class="text-xs-left">
						<TextSnippet :value="props.item.description" :snippet-length="80" class="py-2" />
					</td>
					<td class="text-xs-left">{{ props.item.memberCount }}</td>
					<td class="text-xs-left"><AppDate :date="props.item.lastUpdatedDateUTC" /></td>
					<td class="justify-center px-0">
						<v-icon small class="mr-2" @click="onEditClick(props.item)">
							edit
						</v-icon>
						<v-icon small @click="onDeleteClick(props.item)">
							delete
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
		<security-group-editor :dialog="showSecurityGroupEditorDialog" :securityGroup="editingSecurityGroup" @closeDialog="showSecurityGroupEditorDialog = false" />
		<confirmation-dialog
			v-if="showConfirmDeleteDialog"
			:dialog="showConfirmDeleteDialog"
			title="Confirm Delete"
			:text="`Are you sure you want to delete <strong>${deletingSecurityGroup.name}</strong>?`"
			:isConfirming="isDeleting"
			@onConfirm="confirmDelete"
			@onCancel="showConfirmDeleteDialog = false"
		/>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import SecurityGroupEditor from '@/components/security/SecurityGroupEditor';
	import TextSnippet from '@/components/common/TextSnippet'

	export default {
		components: {
			SecurityGroupEditor,
			TextSnippet
		},
		data() {
			return {
				headers: [
					{ text: 'Name', value: 'name' },
					{ text: 'Description', value: 'description' },
					{ text: 'Members', value: 'members' },
					{ text: 'Last Updated', value: 'lastUpdatedDateUTC' },
					{ text: '', value: 'actions', sortable: false }
				],
				pagination: {
					sortBy: 'name'
				},
				editingSecurityGroup: undefined,
				deletingSecurityGroup: null,
				showSecurityGroupEditorDialog: false,
				showConfirmDeleteDialog: false,
				search: ''
			};
		},
		computed: {
			...mapGetters({
				hasLoadedSecurityGroups: 'privileges/hasLoadedSecurityGroups',
				securityGroups: 'privileges/securityGroups',
				isLoading: 'privileges/isLoadingSecurityGroups',
				isDeleting: 'privileges/isDeletingSecurityGroup'
			})
		},
		methods: {
			onAddClick() {
				this.editingSecurityGroup = undefined;
				this.showSecurityGroupEditorDialog = true;
			},
			updateSearch(val) {
				this.search = val;
			},
			onEditClick(securityGroup) {
				this.editingSecurityGroup = JSON.parse(JSON.stringify(securityGroup));
				this.showSecurityGroupEditorDialog = true;
			},
			onDeleteClick(securityGroup) {
				this.showConfirmDeleteDialog = true;
				this.deletingSecurityGroup = securityGroup;
			},
			async confirmDelete() {
				const result = await this.$store.dispatch('privileges/deleteSecurityGroup', this.deletingSecurityGroup.id);
				if (result.isSuccess) {
					this.deletingSecurityGroup = null;
					this.showConfirmDeleteDialog = false;
				}
			}
		}
	};
</script>
